import axios from 'axios';
import { DateTime } from 'luxon';

export async function saveWomTrackingData({ formData, blobPath, specificBlobName, userTracking, path }) {
  try {
    const row = {
      landed_at: DateTime.local().toFormat('yyyy-MM-dd HH:mm:ssZZ'),
      blob_id: specificBlobName,
      FormID: 'azure_app_1',
      ...formData, // make sure this flattens properly for CSV
      ...userTracking
    };

    console.log('row', row);
    console.log(userTracking);
    console.log(userTracking?.referral_source ?? 'self');

    // 1. Upload to blob storage
    const uploadResponse = await axios.post(
      `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/upload-datalake`,
      {
        formData: row,
        blobPath,
        specificBlobName
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('Upload successful:', uploadResponse.data);

    // 2. Open Acuity appt page based on the path selected
    const acuityLinks = {
      EF: import.meta.env.VITE_WOM_EF_ACUITY_LINK,
      NCP: import.meta.env.VITE_WOM_NCP_ACUITY_LINK,
      IVF: import.meta.env.VITE_WOM_VR_ACUITY_LINK
    };
    const link = acuityLinks[path];

    if (link) {
      // attach blob id using environment variable for query param
      const encodedBlobName = encodeURIComponent(specificBlobName);
      const delimiter = link.includes('?') ? '&' : '?';
      const finalLink = `${link}${delimiter}${import.meta.env.VITE_ACUITY_BLOB_NAME_FIELD}=${encodedBlobName}`;

      window.top.location.href = finalLink
      
    } else {
      console.warn('Unknown path:', path);
    }
  } catch (error) {
    console.error('Error in saveIntakeQuestionnaireData:', error.response?.data || error.message);
    throw error;
  }
}
